import { InlineForm } from '@plone/volto/components';
import { withVariationSchemaEnhancer } from '@plone/volto/helpers';

const BlockDataForm = withVariationSchemaEnhancer(InlineForm);

export default BlockDataForm;
